<template>
    <div class="flex m-b-sm" dusk="time-slot">
        <day-select v-model="timeSlot.day" @input="updateParent" class="ad-set-schedule__day-select m-r-sm"></day-select>

        <range-select v-model="timeSlot.range" @input="updateParent" class="ad-set-schedule__range-select m-r-sm"></range-select>

        <div @click="remove" class="flex justify-end items-center ad-set-schedule__remove-button c-clickable">
            <i class="fa fa-trash-o" aria-hidden="true"></i>
        </div>

        <div class="flex justify-center items-center ad-set-schedule__overlap-button">
            <i class="fa fa-exclamation-triangle theme-fg--red" v-if="errorsList" v-tooltip.right="errorsList" aria-hidden="true" dusk="warning-icon"></i>
        </div>
    </div>
</template>

<script>
import DaySelect from './selects/day-select';
import RangeSelect from './selects/range-select';

export default {
    props: {
        timeSlot: Object,
        overlaps: Number
    },
    computed: {
        errorsList() {
            let errors = [];

            if (!this.timeSlot.day) {
                errors.push('Time slot day is invalid.')
            }

            if (!this.timeSlot.range.isValid()) {
                errors.push('Time slot range is invalid.')
            }

            if (this.overlaps) {
                 errors.push( `Time slot overlaps with ${this.overlaps} other time slot(s).`);
            }

            return errors.join('<br>');
        }
    },
    methods: {
        remove() {
            this.$emit('remove');
        },
        updateParent() {
            this.$emit('input');
        }
    },
    components: {
        DaySelect,
        RangeSelect
    }
}
</script>
